import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let data = {
   加载完成: false,
   当前员工: null,
   当前商户: null,
   当前门店: null,
   所有门店list: [],
   有权限门店list: [],
   分组门店list: [],  //淘汰
   配送线路list: [],
   打印模版list: [],
   商品类别list: [],
   有权限分组门店list: [],

   门店list: [],
   员工list: [],
   商品list: [],

   原材料list: [],


   券类型list: [],
   卡类型list: [],

   版本号: "20260330",
   软件名称: "壹新商家版后台",
   C_终端序列号: '',

   收款方式list: []
};

export default new Vuex.Store({
   state: JSON.parse(JSON.stringify(data)),
   mutations: {
      init(state) {
         //初始化数据,在注销,重新登录的时候会要初始化数据
         Object.assign(state, JSON.parse(JSON.stringify(data)));
      },
      setobj(state, obj) {
         if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
         if (!(obj.value || obj.v)) state[obj.name || obj.n] = null;
         else state[obj.name || obj.n] = { ...(obj.value || obj.v) };
      },
      setarr(state, obj) {
         if (!obj || !(obj.value || obj.v)) return;
         if (!state[obj.name || obj.n]) state[obj.name || obj.n] = [];
         state[obj.name || obj.n].push(...(obj.value || obj.v));
      },
      setvalue(state, obj) {
         state[obj.name || obj.n] = obj.value || obj.v;
      },
      setobjarr(state, obj) {
         if (!obj || !(obj.value || obj.v)) return;
         if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
         if (!state[obj.name || obj.n][obj.name2 || obj.n2]) Vue.set(state[obj.name || obj.n], obj.name2 || obj.n2, []);
         state[obj.name || obj.n][obj.name2 || obj.n2].push(...(obj.value || obj.v));
      },
      setobjvalue(state, obj) {
         if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
         if (!state[obj.name || obj.n][obj.name2 || obj.n2]) Vue.set(state[obj.name || obj.n], obj.name2 || obj.n2, obj.value || obj.v);
         else state[obj.name || obj.n][obj.name2 || obj.n2] = obj.value || obj.v;
      },
      setobjobj(state, obj) {
         if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
         Vue.set(state[obj.name || obj.n], obj.name2 || obj.n2, obj.value || obj.v);
      },
      cleararr(state, obj) {
         let name = obj.name || obj.n || obj;
         if (!state[name]) state[name] = [];
         state[name].splice(0, state[name].length);
      },
      clearobjarr(state, obj) {
         if (!state[obj.name || obj.n]) state[obj.name || obj.n] = {};
         state[obj.name || obj.n][obj.name2 || obj.n2].splice(0, state[obj.name || obj.n][obj.name2 || obj.n2].length);
      },
   },
   actions: {
      async 获取员工({ commit, state }) {
         let result = await window.vm.$postAsync("/api/boss", {
            cmd: "员工_list",
            I_商户Id: state.当前商户.I_商户Id,
         });
         commit("cleararr", { name: "员工list" });
         commit("setarr", { name: "员工list", value: result.data });
      },
      async 获取门店({ commit, state }) {
         let result = await window.vm.$postAsync('/api/boss', {
            cmd: '门店_list',
            I_商户Id: state.当前商户.I_商户Id,
            C_门店类型: '全部'
         });
         const list = result.data;

         commit("cleararr", { name: '门店list' });
         commit("setarr", { name: '门店list', value: list });
      },
      async 获取原材料({ commit, state }) {
         let result = await window.vm.$postAsync("/api/boss", {
            cmd: "原材料_list",
            I_商户Id: state.当前商户.I_商户Id,
            I_门店Id: state.当前门店.I_门店Id,
            B_门店没有查商户: true,
         });
         commit("cleararr", { name: "原材料list" });
         commit("setarr", { name: "原材料list", value: result.data });
      },
      async 获取配送线路({ commit, state }) {
         let result = await window.vm.$postAsync("/api/boss", {
            cmd: "配送线路_list",
            I_商户Id: state.当前门店.I_商户Id,
            I_门店Id: state.当前门店.I_门店Id,
         });
         commit("cleararr", { name: "配送线路list" });
         commit("setarr", { name: "配送线路list", value: result.data });
      },
      async 获取打印模版({ commit, state }) {
         let result = await window.vm.$postAsync("/api/boss", {
            cmd: "配送打印模版_list",
            I_商户Id: state.当前门店.I_商户Id,
            I_门店Id: state.当前门店.I_门店Id,
         });
         commit("cleararr", { name: "打印模版list" });
         commit("setarr", { name: "打印模版list", value: result.data });
      },
      async 获取商品({ commit, state }) {
         let result = await window.vm.$postAsync("/api/boss", {
            cmd: "商品_list",
            I_商户Id: state.当前门店?.I_商户Id,
            I_门店Id: state.当前门店?.I_门店Id,
         });
         commit("cleararr", { name: "商品list" });
         commit("setarr", { name: "商品list", value: result.data });
      },

      async 获取卡类型({ commit, state }, showLoadding = true) {
         let result = await window.vm.$postAsync('/api/boss', {
            cmd: '卡类型_list',
            I_商户Id: state.当前门店.I_商户Id,
         }, showLoadding);
         result.data.forEach(e => {
            if (!e.J_卡类型参数) e.J_卡类型参数 = {};
            if (!e.J_卡类型参数.J_充值赠送比例) e.J_卡类型参数.J_充值赠送比例 = [];
            e.J_卡类型参数.J_充值赠送比例.forEach(row => {
               if (typeof row.B_长期有效 == 'undefined') row.B_长期有效 = true;
               if (typeof row.J_适用门店 == 'undefined') row.J_适用门店 = [];
            });
         })
         commit("cleararr", { name: '卡类型list' })
         commit("setarr", { name: '卡类型list', value: result.data });
      },
      async 获取券类型({ commit, state }, showLoadding = true) {
         let result = await window.vm.$postAsync(
            "/api/boss",
            {
               cmd: "券类型_list",
               I_商户Id: state.当前门店.I_商户Id,
               I_门店Id: state.当前门店.I_门店Id,
            },
            showLoadding
         );
         commit("cleararr", { name: "券类型list" });
         commit("setarr", { name: "券类型list", value: result.data });
      },
   },
   modules: {},
});
